const YMAPS_STYLESHEET_SELECTOR = 'link[rel="stylesheet"][href*="maps-front-jsapi"]';

/**
 * Yandex Maps API подключает свои стили `<link>` в `document.head`, из-за чего внутри shadow DOM
 * контейнер карты остаётся нулевого размера. Копируем эти стили в shadow root и следим за новыми:
 * контролы и другие модули догружают стили уже после инициализации карты.
 */
export const syncYmapsStylesToShadowRoot = (root: ShadowRoot): (() => void) => {
  const mirrorStylesheets = () => {
    document.querySelectorAll<HTMLLinkElement>(YMAPS_STYLESHEET_SELECTOR).forEach(({ href }) => {
      if (root.querySelector(`link[href="${href}"]`)) {
        return;
      }

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      root.prepend(link);
    });
  };

  mirrorStylesheets();

  const observer = new MutationObserver(mirrorStylesheets);
  observer.observe(document.head, { childList: true });

  return () => {
    observer.disconnect();
  };
};
